var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 162,
    viewBox: "0 0 118 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10.0675V150.991C0 156.527 4.52882 161.056 10.0644 161.056H107.932C113.47 161.056 118 156.525 118 150.988V37.0728C118 33.9821 116.772 31.018 114.587 28.8324L89.1676 3.41311C86.982 1.22781 84.0179 0 80.9272 0H10.0675C4.5304 0 0 4.5304 0 10.0675Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8259 77.6983H91.178C92.7819 77.6983 94.0821 76.3982 94.0821 74.7943V67.7126C94.0821 66.1086 92.7819 64.8085 91.178 64.8085H26.8259C25.222 64.8085 23.9219 66.1086 23.9219 67.7126V74.7943C23.9219 76.3982 25.222 77.6983 26.8259 77.6983Z",
    fill: "#EBEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8259 97.8206H91.178C92.7819 97.8206 94.0821 96.5204 94.0821 94.9165V87.8348C94.0821 86.2309 92.7819 84.9308 91.178 84.9308H26.8259C25.222 84.9308 23.9219 86.2309 23.9219 87.8348V94.9165C23.9219 96.5204 25.222 97.8206 26.8259 97.8206Z",
    fill: "#EBEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8259 117.94H91.178C92.7819 117.94 94.0821 116.64 94.0821 115.036V107.955C94.0821 106.351 92.7819 105.051 91.178 105.051H26.8259C25.222 105.051 23.9219 106.351 23.9219 107.955V115.037C23.9219 116.64 25.222 117.94 26.8259 117.94Z",
    fill: "#EBEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0244 138.062H58.6003C59.7615 138.062 60.7028 137.121 60.7028 135.96V127.275C60.7028 126.114 59.7615 125.173 58.6003 125.173H26.0244C24.8633 125.173 23.9219 126.114 23.9219 127.275V135.96C23.9219 137.121 24.8633 138.062 26.0244 138.062Z",
    fill: "#EBEFF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1664 3.41434C87.6696 1.91747 85.807 0.870292 83.7891 0.358704V33.1768L117.999 67.3868V37.0737C117.999 33.983 116.771 31.0189 114.586 28.8333L89.1664 3.41434Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.656 34.246C117.694 34.4077 117.728 34.5652 117.759 34.7171H86.9225C84.7391 34.7171 82.9688 32.9471 82.9688 30.7634V0.183685C83.2097 0.226633 83.463 0.276845 83.7241 0.334635C86.0228 0.843066 88.1187 2.02509 89.7836 3.68964L114.307 28.2127C115.965 29.871 117.129 31.9612 117.656 34.246Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118 141.224V150.988C118 156.525 113.47 161.055 107.932 161.055H10.0644C4.52882 161.055 0 156.526 0 150.991V141.224H118Z",
    fill: "url(#paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 28.1004,
    y1: 62.7949,
    x2: 104.711,
    y2: 139.405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7FAEF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C8DF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 107.981,
    y1: 54.8637,
    x2: 95.8227,
    y2: 19.3367,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8DF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4256AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 86.8773,
    y1: 18.5462,
    x2: 101,
    y2: 32.6692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C5FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7FAEF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 59,
    y1: 146.434,
    x2: 59,
    y2: 162.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C8DF1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4256AC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFiles);
export default __webpack_public_path__ + "static/media/no-files.eae7d6c26e2d0d0badfc6d194180aa93.svg";
export { ForwardRef as ReactComponent };